export const oneIdPlaceholder = () => ({
    on: (event, listener) => {},
    off: (event, listener) => {},
    getGuest: () => Promise.resolve(null),
    getGuestNewsletters: () => Promise.resolve(null),
    getInlineNewsletters: (campaignId, options) => Promise.resolve(null),
    launchNewsletters: (campaignId, optionalConfig) => Promise.resolve(),
    setInlineNewsletters: (data, options) => Promise.resolve(),
});
